import $axios from './index'

// 订单管理页面，查询列表
export function getList(params) {
    // return $axios.get('/data/queryTransaction',params)
    return $axios.get('/api/transaction/query',params)
}

// 请求手工退款订单翻转（实际并未退款）
export function fakeManuanlRefund(data) {
    return $axios.post('/api/refund', data)
}


// 获取所有景区列表
export function getStoreList(params) {
    // return $axios.get('/data/queryStoreList', params);
    return $axios.get('/api/stores/query', params);
}

// 获取退款日志
export function getRefundLog(params) {
    return $axios.get('/api/refund/log', params);
}

// 获取退款日志页面中的用户列表
export function getUserList(params){
    return $axios.get('/api/refund/user', params);
}
export function getrefundLogDownload(params) {
    const url = '/api/refund/log/export'
    return $axios.get(url, params, 'blob')
}